export default __webpack_public_path__ + "static/media/celebration.740a90ca.jpg";